import SelectReport from "../components/SelectReport";
import * as actions from "../../common/actions";
import { StoreState } from "../../common/types/index";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  initialCBSState,
  initialCBFState,
  initialSISState,
  initialSIFState,
  defaultSelectedStatesValue,
} from "../../refdata/FilterOptions";

export function mapStateToProps({ query }: StoreState.All) {
  return {
    selectedReport: query.filters.selectedReport,
    previousReport: query.filters.previousReport,
    selectedStartDate: query.filters.selectedStartDate,
    selectedEndDate: query.filters.selectedEndDate,
    selectedStates: query.filters.selectedStates,
    previousLocations: query.filters.previousLocations,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onChange: (
      selectedReport: string,
      previousReport: string,
      selectedStartDate: string,
      selectedEndDate: string,
      selectedStates: string[],
      previousLocations: string[],
    ) => {

      const report: { [key: string]: any } = {
        CBS: initialCBSState,
        CBF: initialCBFState,
        SIS: initialSISState,
        SIF: initialSIFState,
      };

      //keeps current selections for start and end date
      report[selectedReport].filters.selectedStartDate = selectedStartDate;
      report[selectedReport].filters.selectedEndDate = selectedEndDate;

      // save current state selections
      report[selectedReport].filters.previousLocations = selectedStates;

      // save current report selection to previous report
      report[selectedReport].filters.previousReport = selectedReport;

      if (selectedReport === "SIS") {
        // current report is SIS, so use default values
        report[selectedReport].filters.selectedStates = defaultSelectedStatesValue;
      }
      else if (previousLocations && previousReport === "SIS") {
        // previousLocations has been set, and the previous report was SIS, so use previousLocations
        report[selectedReport].filters.selectedStates = previousLocations;
      }
      else {
        // otherwise use selected values
        report[selectedReport].filters.selectedStates = selectedStates;
      }

      dispatch(actions.resetState(report[selectedReport]));
      dispatch(actions.updateFilter("selectedReport", selectedReport));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectReport);
